export default function LoadingSpan ({ textColor }) {


    return (
        <div
            className='flex justify-center gap-1 mt-4 items-center'>
            <div
                className='h-[8px] w-[8px] bg-black rounded-full animate-bounce [animation-delay:-0.2s]'></div>
            <div
                className='h-[8px] w-[8px] bg-black rounded-full animate-bounce [animation-delay:-0.6s]'></div>
            <div className='h-[8px] w-[8px] bg-black rounded-full animate-bounce [animation-delay:-0.4s]'></div>
        </div>
    )
}